import * as angular from "angular";
import {IController} from "angular";

export class AgentsTableViewComponent implements IController {
  filters: any;

  public loadLimit: number;
  public agentsRef: any;
  public infiniteScroll: any;

  constructor(private $agents, private $infiniteScroll) {
  }

  $onInit() {
    this.loadLimit = 20;
    this.agentsRef = this.$agents();

    this.agentsRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.agentsRef, this.loadLimit, {getFullData: true});
  }


  private _getQueryPayload() {
    return {
      ...this.filters,
      limit: this.loadLimit
    };
  }

}

angular
  .module('bringoz.admin.dashboards')
  .component('agentsTableView', {
    bindings: {
      filters: '<',
    },
    template: require('./agents-table-view.html').default,
    controller: AgentsTableViewComponent
  });
